import React, { Component } from 'react';
import './Champion.css';
import Img from '../../StableImage';
import User from '../../User';

export default class Champion extends Component {

	render () {

		if (!this.props.src)
			return <div className="gg-champion"></div>;

    	let src = this.props.src;
    	let model = src.key ? src : src.model;

    	let level = model.level || this.props.level || User.databank[model.key][User.difficulty].level;
    	let imgIndex = 0;
    	while (imgIndex+1 < model.chibi.length && model.chibi[imgIndex+1].from <= level)
    		imgIndex++;

		return(
      		<div className="gg-champion">
			 	<Img key={model.key} alt="" src={model.chibi[imgIndex].img}/>
      		</div>
		);
	}
}
